<div #tooltip class="db-tooltip db-tooltip_on_{{position}} db-tooltip_align_{{align}} db-tooltip_color_{{color}}" [ngStyle]="tooltipStyle" [innerHTML]="content"></div>
